if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';
        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');

            // 🔧 Neu: zuerst <product-info>, dann Fallbacks
            this.productElement =
              responseHTML.querySelector('product-info') ||
              responseHTML.querySelector('section[id^="MainProduct-"]') ||
              responseHTML.querySelector('.product');

            if (!this.productElement) {
              console.warn('QuickAdd: product element not found in fetched HTML.');
              return; // kein Crash mehr
            }

            // 🔧 classList nur nutzen, wenn vorhanden
            if (this.productElement.classList) {
              this.productElement.classList.forEach((classApplied) => {
                if (classApplied.startsWith('color-') || classApplied === 'gradient') {
                  this.modalContent.classList.add(classApplied);
                }
              });
            }

            this.preventDuplicatedIDs(this.productElement);
            this.removeDOMElements(this.productElement);

            // deine bestehende setInnerHTML behalten
            this.setInnerHTML(this.modalContent, this.productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic(this.modalContent);
            this.updateImageSizes(this.modalContent);
            this.preventVariantURLSwitching(this.modalContent);
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      // 🔧 Methoden nehmen jetzt das Ziel-Element entgegen
      preventVariantURLSwitching(scope) {
        const variantPicker = scope.querySelector('variant-radios,variant-selects,product-info');
        if (!variantPicker) return;
        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(scope) {
        const pickupAvailability = scope.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();
        scope.querySelectorAll('product-modal, modal-dialog').forEach((el) => el.remove());
      }

      preventDuplicatedIDs(scope) {
        const sectionId = scope.dataset.section;
        if (!sectionId) return;
        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        scope.innerHTML = scope.innerHTML.replaceAll(oldId, newId);
        Array.from(scope.attributes).forEach((attr) => {
          if (attr.value && attr.value.includes(oldId)) {
            scope.setAttribute(attr.name, attr.value.replace(oldId, newId));
          }
        });
        scope.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(scope) {
        const galleryList = scope.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;
        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(scope) {
        const product = scope.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;
        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;
        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }
        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
